import useAppSelector from '../../hooks/useAppSelector';
import { CustomContentModalData, ModalProps } from './Modal.types';
import ModalRenderer from './ModalRenderer';

const CustomContentModal = ({ modalId, stackIndex }: ModalProps) => {
  const modalData = useAppSelector(
    (state) => state.modal.activeModals[modalId],
  );

  const { customContent, size, title, width, backdrop } =
    modalData as CustomContentModalData;

  return (
    <ModalRenderer
      width={width}
      customContent={customContent}
      modalId={modalId}
      size={size}
      stackIndex={stackIndex}
      title={title}
      backdrop={backdrop}
    />
  );
};

export default CustomContentModal;
